import { space } from "@octopusdeploy/design-system-tokens";
export function ExternalLinkIcon() {
    return <em style={{ marginLeft: space[4] }} className="fa-solid fa-external-link" aria-hidden="true"/>;
}
